import { Query } from '@domain/graphql.types';
import { QuerySiteNetworks } from '@infrastructure/graphql';
import { useCallback } from 'react';
import { useQuery } from 'urql';

const useSiteNetworksQuery = () => {
  const [{ data, fetching, error }, reexecuteQuery] = useQuery<Pick<Query, 'siteNetworks'>>({ query: QuerySiteNetworks });

  const retry = useCallback(() => reexecuteQuery({ requestPolicy: 'network-only' }), [reexecuteQuery]);

  return {
    data: data?.siteNetworks,
    error,
    fetching,
    retry,
  };
};

export default useSiteNetworksQuery;
